export default "__VITE_ASSET__B$WoHvw6__"